/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientSeminarPaymentResponse } from './ClientSeminarPaymentResponse';
import type { ClientSeminarSessionResponse } from './ClientSeminarSessionResponse';
import type { SeminarOccurrenceLifecycleStatus } from './SeminarOccurrenceLifecycleStatus';
import type { SeminarOccurrenceStatus } from './SeminarOccurrenceStatus';
import type { SeminarRegistrationSource } from './SeminarRegistrationSource';
import type { SeminarRegistrationStatus } from './SeminarRegistrationStatus';
export type ClientSeminarRegistrationResponse = {
    occurrenceStatus: SeminarOccurrenceStatus;
    /**
     * Derived from publication status, registration window, and session times
     */
    lifecycleStatus: SeminarOccurrenceLifecycleStatus;
    status: SeminarRegistrationStatus;
    source: SeminarRegistrationSource;
    registeredAt: string;
    confirmedAt: string | null;
    cancelledAt: string | null;
    /**
     * Public seminar detail URL when the page is available
     */
    publicDetailUrl?: string | null;
    id: number;
    occurrenceId: number;
    seminarId: number;
    seminarTitle: string;
    seminarSubtitle: string | null;
    locationType: ClientSeminarRegistrationResponse.locationType;
    locationName: string | null;
    occurrenceLabel: string | null;
    seats: number;
    price: string;
    taxRate: string | null;
    isOutage: boolean;
    outageFeePrice: string | null;
    outageWouldApply: boolean;
    canCancel: boolean;
    canPayOnline: boolean;
    sessions: Array<ClientSeminarSessionResponse>;
    payment: ClientSeminarPaymentResponse | null;
};
export namespace ClientSeminarRegistrationResponse {
    export enum locationType {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
        NOT_FIXED = 'not-fixed',
    }
}

